import { useNavigate } from "react-router-dom";
import Button from "../components/Button";
import styles from "./EventMenu.module.css";
import React, { useState } from "react";
import PrintEventFOH from "../print/PrintEventFOH";
import PrintEventBOH from "../print/PrintEventBOH";
import { flashAlert, popup, popupClose } from "../global_js";
import PrintEventInvoice from "../print/PrintEventInvoice";
import CopyEventModal from "../modals/CopyEventModal";
import PrintEventSummary from "../print/PrintEventSummary";

function EventMenu({ eventData, serverData }) {
  const navigate = useNavigate();
  const [foh, setFoh] = useState(false);
  const [boh, setBoh] = useState(false);
  const [invoice, setInvoice] = useState(false);
  const [summary, setSummary] = useState(false);

  const userData = JSON.parse(localStorage.getItem("userLogin"));
  const banDateMonth = new Date(eventData.BanDate);

  const handleDeleteEvent = async (eventStatus) => {
    const deleteStatus = eventStatus == "N" ? "Y" : "N";
    await fetch("/api/event/", {
      method: "delete",
      body: new URLSearchParams({
        id: eventData.idBanquetHeader,
        userId: userData.userId,
        delete: deleteStatus,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        flashAlert("Event Deleted");
        navigate(`/`);
      });
  };

  const handleCopyEvent = async (e) => {
    e.preventDefault();
    const elements = e.target.elements;

    await fetch("/api/event/copy/", {
      method: "post",
      body: new URLSearchParams({
        id: eventData.idBanquetHeader,
        banName: elements.banName.value,
        banDate: elements.banDate.value,
        user: userData.user,
        userId: userData.userId,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.newId) {
          navigate(`../event/` + data.newId);
          navigate(0);
        }
      });
  };

  const handeMenuClick = async (report) => {
    switch (report) {
      case "foh":
        await setFoh(false);
        await setFoh(true);
        break;
      case "boh":
        await setBoh(false);
        await setBoh(true);
        break;
      case "invoice":
        await setInvoice(false);
        await setInvoice(true);
        break;
      case "summary":
        await setSummary(false);
        await setSummary(true);
        break;
    }
  };

  return (
    <>
      <div className={styles.backButton}>
        <Button
          type="tertiary"
          onClick={(e) => {
            e.preventDefault();
            sessionStorage.setItem("calDate", banDateMonth);
            navigate("/");
          }}
        >
          Back to Calendar
        </Button>
      </div>

      <ul className={styles.eventButtons}>
        <li>
          <Button type="secondary" onClick={() => handeMenuClick("foh")}>
            Print Event Detail FOH
          </Button>
          {foh && <PrintEventFOH eventData={eventData} serverData={serverData} />}
        </li>
        <li>
          <Button type="secondary" onClick={() => handeMenuClick("boh")}>
            Print Event Detail BOH
          </Button>
          {boh && <PrintEventBOH eventData={eventData} serverData={serverData} />}
        </li>

        <li>
          <Button type="secondary" onClick={() => handeMenuClick("invoice")}>
            Print Customer Invoice
          </Button>
          {invoice && <PrintEventInvoice eventData={eventData} serverData={serverData} />}
        </li>
        <li>
          <Button type="secondary" onClick={() => handeMenuClick("summary")}>
            Print Event Summary
          </Button>
          {summary && <PrintEventSummary eventData={eventData} serverData={serverData} />}
        </li>
        <li>
          <CopyEventModal eventdata={eventData} handleCopyEvent={handleCopyEvent} />
        </li>
        <li>
          <Button
            type="secondary"
            onClick={(e) => {
              popup(
                `${eventData.Deleted == "Y" ? "Restore" : "Delete"} Event`,
                `Are you sure you want to ${eventData.Deleted == "Y" ? "restore" : "delete"} this banquet event?`,
                () => handleDeleteEvent(eventData.Deleted),
                e
              );
            }}
          >
            {eventData.Deleted == "N" ? "Delete Event" : "Restore Event"}
          </Button>
        </li>
      </ul>
    </>
  );
}

export default EventMenu;
